import { createOnboardingRoutes } from "./onboardingConfig"

const onboardingRoutes = createOnboardingRoutes()

export default onboardingRoutes
